export default function ArrowRight() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="Fundamental / Arrow">
				<path
					id="Stroke"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.2929 17.2929C12.9024 17.6834 12.9024 18.3166 13.2929 18.7071C13.6834 19.0976 14.3166 19.0976 14.7071 18.7071L19.2929 14.1213C20.4645 12.9497 20.4645 11.0503 19.2929 9.87868L14.7071 5.29289C14.3166 4.90237 13.6834 4.90237 13.2929 5.29289C12.9024 5.68342 12.9024 6.31658 13.2929 6.70711L17.5858 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H17.5858L13.2929 17.2929Z"
					fill="#fff"
				/>
			</g>
		</svg>
	);
}
